import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Clock, MessageCircle } from 'lucide-react';
import { Button } from './Button';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="precio" className="py-10 md:py-20 bg-stone-50" data-id="element-109">
      <div className="container mx-auto px-4 md:px-6" data-id="element-110">
        {/* ===== MAIN CARD — Plantilla de Finanzas Personales ===== */}
        <div className="max-w-md mx-auto" data-id="element-111">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden border border-gray-100 relative" data-id="element-112">
            <div className="bg-teal-600 p-3 md:p-6 text-center text-white" data-id="element-113">
              <h2 className="text-lg md:text-2xl font-bold mb-0.5 md:mb-2" data-id="element-114">
                Plantilla de Finanzas Personales
              </h2>
              <p className="opacity-90 text-[10px] md:text-sm" data-id="element-115">
                Oferta por tiempo limitado
              </p>
            </div>

            <div className="px-4 md:px-10 pt-3 md:pt-8 pb-5 md:pb-10" data-id="element-116">
              {/* Product Image */}
              <div className="mb-2 flex justify-center" data-id="element-117">
                <img src="https://cdn.magicpatterns.com/uploads/aCbGv9Ta8whf6nYMwBmm7G/Logos_Verduleria_y_Fruteria_Simple_Verde_20260119_022532_0000.png" alt="Plantilla de Finanzas Personales en múltiples dispositivos" className="w-full max-w-[240px] md:max-w-none h-auto" data-id="element-118" />
              </div>

              {/* Countdown Timer */}
              <div className="mb-2 md:mb-6 bg-red-50 border border-red-100 rounded-lg p-1.5 md:p-3 flex items-center justify-center gap-1 md:gap-2 text-red-700 text-[10px] md:text-sm font-medium" data-id="element-119">
                <Clock className="w-3 h-3 md:w-4 md:h-4" data-id="element-120" />
                <span data-id="element-121">La oferta termina en:</span>
                <span className="font-mono font-bold text-xs md:text-base" data-id="element-122">
                  {String(timeLeft.hours).padStart(2, '0')}:
                  {String(timeLeft.minutes).padStart(2, '0')}:
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
              </div>

              {/* Price */}
              <div className="flex flex-col items-center mb-3 md:mb-8" data-id="element-123">
                <span className="text-gray-400 line-through text-sm md:text-xl mb-0.5" data-id="element-124">
                  $49.990
                </span>
                <div className="flex items-baseline gap-1" data-id="element-125">
                  <span className="text-3xl md:text-5xl font-bold text-gray-900" data-id="element-126">
                    $19.990
                  </span>
                  <span className="text-gray-500 font-medium text-xs md:text-base" data-id="element-127">
                    ARS
                  </span>
                </div>
                <span className="inline-block mt-1.5 md:mt-4 px-2.5 py-0.5 md:py-1 bg-teal-50 text-teal-700 text-[9px] md:text-xs font-bold rounded-full uppercase tracking-wide" data-id="element-128">
                  Pago Único • Acceso Inmediato
                </span>
              </div>

              {/* Features */}
              <ul className="space-y-1.5 md:space-y-4 mb-3 md:mb-8" data-id="element-129">
                {['Plantilla Editable en Google Sheets', 'Gestión de Ingresos y Gastos', 'Control de Ahorros y Deudas', 'BONUS: Planificador Imprimible', 'BONUS: Video Tutorial Paso a Paso', 'Acceso de por vida'].map((item, index) => <li key={index} className="flex items-start gap-2 md:gap-3" data-id="element-130">
                    <Check className="w-3.5 h-3.5 md:w-5 md:h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-131" />
                    <span className="text-gray-700 text-xs md:text-base" data-id="element-132">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <Button href="https://checkout.tuvidasimple.shop/cart/44165757272152:1" fullWidth className="mb-2 md:mb-4 !text-sm md:!text-base" data-id="element-133">
                Acceder ahora
              </Button>

              {/* WhatsApp Support - desktop only */}
              <div className="hidden md:block mb-3 text-center" data-id="element-134">
                <p className="text-sm text-gray-700 mb-1" data-id="element-135">
                  💬 ¿Tuviste algún problema con el pago o con el acceso?
                </p>
                <a href="https://wa.link/ut4sjx" target="_blank" rel="noopener noreferrer" className="text-sm text-teal-600 hover:text-teal-700 font-medium underline inline-flex items-center gap-1" data-id="element-136">
                  <MessageCircle className="w-4 h-4" data-id="element-137" />
                  Escribinos por WhatsApp y te ayudamos en minutos
                </a>
              </div>

              <div className="hidden md:block text-center text-xs text-gray-400 mb-2 leading-relaxed" data-id="element-138">
                <p data-id="element-139">Producto digital – acceso inmediato.</p>
                <p data-id="element-140">
                  El acceso se envía automáticamente por email luego del pago.
                </p>
                <p data-id="element-141">No se envían productos físicos.</p>
              </div>

              <div className="flex items-center justify-center gap-1.5 text-[9px] md:text-xs text-gray-400" data-id="element-142">
                <ShieldCheck className="w-3 h-3 md:w-4 md:h-4" data-id="element-143" />
                <span data-id="element-144">Compra segura y garantizada</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}